import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=21aa7b6a&scoped=true&"
import script from "./TextContent.vue?vue&type=script&lang=js&"
export * from "./TextContent.vue?vue&type=script&lang=js&"
import style0 from "./TextContent.vue?vue&type=style&index=0&id=21aa7b6a&lang=less&scoped=true&"
import style1 from "./TextContent.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa7b6a",
  null
  
)

export default component.exports